import { operators } from '../operators';
import { Nullable } from '../types/Nullable';
import { Operator } from '../types/Operator';
import { OperatorId } from '../types/OperatorId';

export const getOperator = (
  operatorId: Nullable<OperatorId>,
): Nullable<Operator> => {
  if (operatorId === null) {
    return null;
  }

  const operator = operators[operatorId];
  return operator || null;
};
